import React from 'react';
import { Grid, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';

function SuccessRegistred() {
	return (
		<>
			<Grid sx={{ width: '100%', height: '650px' }}>
				<div className='page-container'>
					<Typography sx={{ fontSize: '24px' }}>
						<Grid sx={{ textAlign: 'center' }}>
							<CheckCircleIcon sx={{ fontSize: '50px' }} />
						</Grid>
						<div style={{
							textAlign: 'center',
							marginTop: '20px',
							width: '700px'
						}}>
						<p>
						Ваш аккаунт успешно создан! Теперь необходимо подтвердить адрес электронной почты, чтобы начать пользоваться аккаунтом. 
						</p>
						<p>
						На вашу почту отправлено письмо со ссылкой для активации. Перейдите по этой ссылке, чтобы подтвердить свой адрес.
						</p>	
						</div>
						
					</Typography>
					<Grid
						sx={{
							textAlign: 'center',
							marginTop: '20px',
							color: 'blue',
							textDecoration: 'underline'
						}}
					>
						<Link to='/login'>Войти</Link>
					</Grid>
				</div>
			</Grid>
		</>
	);
}

export default SuccessRegistred;
